import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useProductStore = defineStore("product", {
  state: () => {
    return {
      products: [],
      scope: "all",
      page: 1,
      pageCount: 0,
      perPage: 10,
      queryString: "",
    };
  },
});

export const storeProduct = useProductStore(pinia);
